"use strict";
/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MpStore = void 0;
var set_message_listener_1 = require("../iframe/set-message-listener");
var c360_1 = require("../tracking/c360");
var constants_1 = require("../constants");
var MpStoreEvents;
(function (MpStoreEvents) {
    MpStoreEvents["MP_STORE_STATE_UPDATED"] = "MP_STORE_STATE_UPDATED";
})(MpStoreEvents || (MpStoreEvents = {}));
var MpStore = /** @class */ (function () {
    function MpStore(orchestrator, mpShopClient, trackExperimentStage, trackCustomGoal, reportError) {
        /*
          Warning: don't mutate the top-level state object
          This is wrong: this.state = {};
          This is ok: this.state.something = {};
          Otherwise it may break our state listener hooks
        */
        this.state = {
            isLoading: false,
            multiProducts: [],
        };
        this.queries = {
            MP_GET_STORE_STATE: this.getStoreState.bind(this),
        };
        this.commands = {
            MP_ADD_PRODUCT: this.addProduct.bind(this),
            MP_REMOVE_PRODUCT: this.removeProduct.bind(this),
            MP_SAVE_TO_BASKET: this.saveToBasket.bind(this),
            MP_SEND_C360_EVENT: this.sendC360Event.bind(this),
        };
        this.abortController = new AbortController();
        // mpStore is responsible for
        // firing calls to mpShop
        this.mpShopClient = mpShopClient;
        this.reportError = reportError ? reportError : undefined;
        // Add orchestrator capabilities
        // Commands and queries
        this.orchestrator = orchestrator;
        this.orchestrator.addCommands(this.commands);
        this.orchestrator.addQueries(this.queries);
        // This listener is needed for messages that
        // are posted to the host page by the MFEs
        // rendered inside <iframe>
        (0, set_message_listener_1.setMessageListener)();
    }
    // INTERNAL
    MpStore.prototype._dispatchUpdate = function () {
        this.orchestrator.publish(MpStoreEvents.MP_STORE_STATE_UPDATED, this.state);
    };
    MpStore.prototype._abortRequests = function () {
        this.abortController.abort();
        this.abortController = new AbortController();
    };
    // RESET
    MpStore.prototype.reset = function () {
        this.state.isLoading = false;
        this.state.multiProducts = [];
        this._dispatchUpdate();
        this._abortRequests();
    };
    // QUERIES
    MpStore.prototype.getStoreState = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.state];
            });
        });
    };
    // COMMANDS
    MpStore.prototype.addProduct = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var productId, product;
            return __generator(this, function (_a) {
                productId = payload.productId;
                product = this.state.multiProducts.find(function (item) { return item.productId === productId; });
                if (product) {
                    product.isSelected = true;
                }
                this._dispatchUpdate();
                return [2 /*return*/];
            });
        });
    };
    MpStore.prototype.removeProduct = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var productId, product;
            return __generator(this, function (_a) {
                productId = payload.productId;
                product = this.state.multiProducts.find(function (item) { return item.productId === productId; });
                if (product) {
                    product.isSelected = false;
                }
                this._dispatchUpdate();
                return [2 /*return*/];
            });
        });
    };
    // GET OFFERS
    MpStore.prototype.getOffers = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var ipCountry, pointOfSale, currency, language, basketId, affiliateId, platform, page, response, offers, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._abortRequests();
                        this.state.isLoading = true;
                        this._dispatchUpdate();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        ipCountry = params.ipCountry, pointOfSale = params.pointOfSale, currency = params.currency, language = params.language, basketId = params.basketId, affiliateId = params.affiliateId, platform = params.platform, page = params.page;
                        return [4 /*yield*/, this.mpShopClient.getOffers({
                                basketId: basketId,
                                ipCountry: ipCountry,
                                pointOfSale: pointOfSale,
                                currency: currency,
                                language: language,
                                affiliateId: affiliateId,
                                platform: platform,
                                page: page,
                            })];
                    case 2:
                        response = _a.sent();
                        offers = response.offers;
                        this.state.multiProducts = offers;
                        this.state.isLoading = false;
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.state.isLoading = false;
                        this.state.multiProducts = [];
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 4:
                        this._dispatchUpdate();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // GET BASKET ADDONS
    MpStore.prototype.getBasketAddOns = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var basketId, response, basketAddOns, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._abortRequests();
                        this.state.isLoading = true;
                        this._dispatchUpdate();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        basketId = params.basketId;
                        return [4 /*yield*/, this.mpShopClient.getBasketaddons({
                                basketId: basketId,
                            })];
                    case 2:
                        response = _a.sent();
                        basketAddOns = response.basketAddOns;
                        this.state.multiProducts = basketAddOns;
                        this.state.isLoading = false;
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        this.state.isLoading = false;
                        return [2 /*return*/, Promise.reject(error_2)];
                    case 4:
                        this._dispatchUpdate();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // GET ORDER ADDONS
    MpStore.prototype.getOrderAddOns = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var orderId, anchorProduct, response, orderAddOns, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._abortRequests();
                        this.state.isLoading = true;
                        this._dispatchUpdate();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        orderId = params.orderId, anchorProduct = params.anchorProduct;
                        return [4 /*yield*/, this.mpShopClient.getOrderaddons({
                                orderId: orderId,
                                anchorProduct: anchorProduct,
                            })];
                    case 2:
                        response = _a.sent();
                        orderAddOns = response.orderAddOns;
                        this.state.multiProducts = orderAddOns;
                        this.state.isLoading = false;
                        this._dispatchUpdate();
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        this.state.isLoading = false;
                        return [2 /*return*/, Promise.reject(error_3)];
                    case 4:
                        this._dispatchUpdate();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // SAVE TO BASKET
    MpStore.prototype.saveToBasket = function (basketId) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedProducts, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._abortRequests();
                        this.state.isLoading = true;
                        this._dispatchUpdate();
                        selectedProducts = this.state.multiProducts
                            .filter(function (item) { return item.isSelected; })
                            .map(function (item) {
                            var productId = item.productId, productType = item.productType, distributionId = item.distributionId, adPlat = item.adPlat, token = item.token;
                            return {
                                productId: productId,
                                productType: productType,
                                distributionId: distributionId,
                                adPlat: adPlat || '',
                                token: token || '',
                            };
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        this.generateBookProcessEvents();
                        if (!(selectedProducts.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.mpShopClient.postBasketaddons({
                                postBasketaddonsRequest: {
                                    basketId: basketId,
                                    basketItems: selectedProducts,
                                },
                            }, { signal: this.abortController.signal })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.state.isLoading = false;
                        return [3 /*break*/, 6];
                    case 4:
                        error_4 = _a.sent();
                        this.state.isLoading = false;
                        return [2 /*return*/, Promise.reject(error_4)];
                    case 5:
                        this._dispatchUpdate();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    //This is the only store method that is called from the useC360ViewedTracking hook and other non-react components.
    //Hence we need to catch the error here and report it, because other components will not have reporting context outside of MP components.
    MpStore.prototype.sendC360Event = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var multiProductC360Payload, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        multiProductC360Payload = (0, c360_1.generateMultiProductC360EventPayload)({
                            basePayload: payload,
                            multiProducts: this.state.multiProducts,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, c360_1.trackerSendEvent)(multiProductC360Payload)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        this.flogError(error_5);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This is a called only when transitioning from offers to checkout/payment page.
     * @private
     */
    MpStore.prototype.generateBookProcessEvents = function () {
        var _this = this;
        this.state.multiProducts.forEach(function (product) {
            _this.sendC360Event({
                actionName: 'book_process',
                actionType: 'next',
                anchorProduct: 'FLIGHT',
                anchorStep: 'checkout',
                productType: product.productType,
                productId: product.productId,
            }).catch(_this.flogError);
        }, this);
    };
    MpStore.prototype.flogError = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                error = error || new Error(constants_1.UNKNOWN_ERROR);
                error.message =
                    constants_1.MULTI_PRODUCT_ERROR_PREFIX + (error.message || constants_1.UNKNOWN_ERROR);
                if (this.reportError) {
                    this.reportError(error, constants_1.MULTI_PRODUCT_ACTION_NAME);
                }
                return [2 /*return*/];
            });
        });
    };
    return MpStore;
}());
exports.MpStore = MpStore;
